(function() {
  function hideSoldOutTags() {
    document.querySelectorAll(".product2023 .grid-product__tag--sold-out").forEach(function(prd) {
      prd.style.display = "none";
    });
  }

  window.addEventListener("DOMContentLoaded", hideSoldOutTags);
  window.addEventListener("load", hideSoldOutTags);

  var container = document.querySelector('[data-section-type="recently-viewed"] .index-section .page-width--flush-small div');
  if (container) {
    new MutationObserver(hideSoldOutTags).observe(container, { attributes: true, childList: true, characterData: true });
  }
})();
